import React, { Component } from 'react';
import Pagination from '@material-ui/lab/Pagination';

// const useStyles = (theme) => ({
//   root: {
//     '& > *': {
//       marginTop: theme.spacing(2),
//     },
//   },
// });

export default class Paging extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
    };
  }

  handleChange = (event, value) => {
    this.setState({ page: value });
    this.props.change(value);
  };

  render() {
    // const { page } = this.state;
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Pagination count={this.props.data} page={this.props.defaultPage} onChange={this.handleChange} showFirstButton showLastButton />
      </div>
    );
  }
}
